import { DateTime } from "luxon";
import { observable } from "mobx";

import { EffectTypes, IEffect } from "model";
import { useStores } from "store";

export interface IYoutubeStore {}
export const youtubeStore = observable({} as IYoutubeStore);
